import { isNumber, inRange } from 'lodash-es';
import { getPlural } from 'client/utils/plural';

export const URGENCY_MESSAGE = {
  SELL_IN_DAYS: days => `This car is likely to sell in ${days} ${getPlural('day', days)}`,
  SELL_ANY_DAY: 'This car is likely to sell any day now',
  ASK_FOR_PRICE: 'Ask for dealer’s best price via email',
  ASK_FOR_PRICE_CARMAX: 'Let the dealer know you’re interested',
};

export const DAYS_TO_SELL = {
  FROM: -14,
  TO: 15,
  DEAL_CHECK_MAX: 31,
  PRICE_SUMMARY_MAX: 31,
  FIRST: 1,
};

export function getAskForPriceCopy(useOtherMsg) {
  return useOtherMsg ? URGENCY_MESSAGE.ASK_FOR_PRICE_CARMAX : URGENCY_MESSAGE.ASK_FOR_PRICE;
}

/**
 * Detects what urgency message should be displayed
 * @param {number} daysToSell
 * @param {string} defaultMsg
 * @return {string}
 */
export function getUrgencyMessage(daysToSell, defaultMsg = '') {
  if (!isNumber(daysToSell) || daysToSell < DAYS_TO_SELL.FROM) {
    return defaultMsg;
  }

  if (daysToSell > 0) {
    return daysToSell < DAYS_TO_SELL.PRICE_SUMMARY_MAX ? URGENCY_MESSAGE.SELL_IN_DAYS(daysToSell) : defaultMsg;
  }

  return daysToSell <= 0 && URGENCY_MESSAGE.SELL_ANY_DAY;
}

/**
 * Detects what urgency message should be displayed
 * @param {number} daysToSell
 * @param {boolean} isCarMaxDealer
 * @return {string}
 */
export function getDealCheckUrgencyMessage(daysToSell, isCarMaxDealer) {
  const askForPriceCopy = getAskForPriceCopy(isCarMaxDealer);

  if (!isNumber(daysToSell) || daysToSell >= DAYS_TO_SELL.DEAL_CHECK_MAX) {
    return askForPriceCopy;
  }

  switch (true) {
    case inRange(daysToSell, DAYS_TO_SELL.FIRST, DAYS_TO_SELL.DEAL_CHECK_MAX):
      return URGENCY_MESSAGE.SELL_IN_DAYS(daysToSell);
    case inRange(daysToSell, DAYS_TO_SELL.FROM, DAYS_TO_SELL.FIRST):
      return URGENCY_MESSAGE.SELL_ANY_DAY;
    default:
      return askForPriceCopy;
  }
}

/**
 * Show flame icon only when estimated days to sell >=0 and <=14
 * @param {number} daysToSell
 * @return {boolean}
 */
export function showFlameIcon(daysToSell) {
  return isNumber(daysToSell) && inRange(daysToSell, DAYS_TO_SELL.FROM, DAYS_TO_SELL.TO);
}
